import { firstValueFrom, of } from "rxjs";
import { provideAppInitializer, inject } from "@angular/core";
import { FeatureFlagService } from "../services/feature-flag.service";
import { catchError } from "rxjs/operators";

export const provideFeatureFlag = () =>
  provideAppInitializer(() => {
    const featureFlagService = inject(FeatureFlagService);
    return firstValueFrom(
      featureFlagService
        .fetchFeatureFlags()
        .pipe(
          catchError((error) => {
            console.error("Error fetching feature flags:", error);
            return of(null);
          }),
        ),
    );
  });
